var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CHECKMEPRO_COMAND_DEVICEINFO, CHECKMEPRO_COMAND_ECG_FILE, CHECKMEPRO_COMAND_ECG_ITEM_FILE, CHECKMEPRO_COMAND_END, CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE, CHECKMEPRO_COMAND_READDATA, CHECKMEPRO_COMAND_STARTREAD, CHECKMEPRO_SERVICE_UUID, } from "../BleContstants";
import { parseEcgItem } from "../model/checkmepro/ECGItem";
import { crc8, getEndReadPackage, getInfoPackage, getReadDataPackage, getReadStartPackage, } from "./CheckMeProBlePackages";
import { reactive, ref } from "vue";
import { getFileName, safeWrite } from "./EshBleUtils";
import { parseCheckMeProUser } from "../model/checkmepro/User";
import { parsePressureItem, } from "../model/checkmepro/PressureItem";
import { parseTemperatureItem } from "../model/checkmepro/TemperatureItem";
import { parseSPO2Items } from "../model/checkmepro/SPO2Item";
var chekMeProBLEInst = reactive({});
var softWait = 300;
var longWait = 500;
var delay = function (delayInms) {
    return new Promise(function (resolve) { return setTimeout(resolve, delayInms); });
};
var CheckMeProBleDevice = /** @class */ (function () {
    function CheckMeProBleDevice() {
        this.globalCheckMeProReceiveData = [];
        this.fileCheckMeProGlobalReceiveData = [];
        this.title = "CheckMe Pro";
    }
    CheckMeProBleDevice.getInstance = function () {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new CheckMeProBleDevice();
        this.instance.progress = ref("");
        return this.instance;
    };
    CheckMeProBleDevice.prototype.setupDevice = function () {
        return __awaiter(this, void 0, Promise, function () {
            var server, service, characteristics;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.device.gatt.connect()];
                    case 1:
                        server = _a.sent();
                        return [4 /*yield*/, server.getPrimaryService(CHECKMEPRO_SERVICE_UUID)];
                    case 2:
                        service = _a.sent();
                        return [4 /*yield*/, service.getCharacteristics()];
                    case 3:
                        characteristics = _a.sent();
                        this.NotificationCharacteristic = characteristics[0];
                        this.WriteCharacteristic = characteristics[1];
                        this.NotificationCharacteristic.addEventListener("characteristicvaluechanged", this.handleData);
                        this.NotificationCharacteristic.startNotifications();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.infoDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_DEVICEINFO;
                        safeWrite(this.WriteCharacteristic, getInfoPackage());
                        _a.label = 1;
                    case 1:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, delay(softWait)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.readUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var iDelay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, delay(softWait)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [4 /*yield*/, delay(softWait)];
                    case 3:
                        _a.sent();
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
                        safeWrite(this.WriteCharacteristic, getReadStartPackage("usr.dat"));
                        iDelay = 0;
                        _a.label = 4;
                    case 4:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, delay(softWait)];
                    case 5:
                        _a.sent();
                        iDelay += 1;
                        if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0) {
                            return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 4];
                    case 6:
                        this.Users = parseCheckMeProUser(this.fileCheckMeProGlobalReceiveData);
                        this.fileCheckMeProGlobalReceiveData = [];
                        this.resetValues();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.readEcg = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, delay(softWait)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [4 /*yield*/, delay(softWait)];
                    case 3:
                        _a.sent();
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
                        safeWrite(this.WriteCharacteristic, getReadStartPackage("ecg.dat"));
                        _a.label = 4;
                    case 4:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, delay(softWait)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 6:
                        this.ECGs = parseEcgItem(this.fileCheckMeProGlobalReceiveData);
                        this.fileCheckMeProGlobalReceiveData = [];
                        this.resetValues();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.readPressure = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, iDelay, pressuerItems;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, delay(softWait)];
                    case 1:
                        _b.sent();
                        if (!this.Pressures)
                            this.Pressures = [];
                        _b.label = 2;
                    case 2:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, delay(softWait)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 2];
                    case 4:
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE;
                        i = 0;
                        _b.label = 5;
                    case 5:
                        if (!(i < this.Users.length)) return [3 /*break*/, 15];
                        return [4 /*yield*/, delay(softWait)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        if (!(this.LAST_COMMAND != 0 && i > 0)) return [3 /*break*/, 9];
                        return [4 /*yield*/, delay(softWait)];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 9:
                        safeWrite(this.WriteCharacteristic, getReadStartPackage(i + "nibp.dat"));
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE;
                        iDelay = 0;
                        _b.label = 10;
                    case 10:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 12];
                        return [4 /*yield*/, delay(softWait)];
                    case 11:
                        _b.sent();
                        if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0) {
                            this.LAST_COMMAND = 0;
                        }
                        iDelay += 1;
                        return [3 /*break*/, 10];
                    case 12:
                        if (this.fileCheckMeProGlobalReceiveData.length >= 8) {
                            pressuerItems = parsePressureItem(this.fileCheckMeProGlobalReceiveData, this.Users[i]);
                            (_a = this.Pressures).push.apply(_a, pressuerItems);
                        }
                        this.fileCheckMeProGlobalReceiveData = [];
                        this.resetValues();
                        return [4 /*yield*/, delay(softWait)];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        i++;
                        return [3 /*break*/, 5];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.readTemperature = function () {
        return __awaiter(this, void 0, void 0, function () {
            var iDelay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, delay(softWait)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [4 /*yield*/, delay(softWait)];
                    case 3:
                        _a.sent();
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
                        safeWrite(this.WriteCharacteristic, getReadStartPackage("temp.dat"));
                        iDelay = 0;
                        _a.label = 4;
                    case 4:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, delay(softWait)];
                    case 5:
                        _a.sent();
                        if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0) {
                            this.LAST_COMMAND = 0;
                        }
                        iDelay += 1;
                        return [3 /*break*/, 4];
                    case 6:
                        this.Temperatures = parseTemperatureItem(this.fileCheckMeProGlobalReceiveData);
                        this.fileCheckMeProGlobalReceiveData = [];
                        this.resetValues();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.readSpo2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var iDelay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, delay(softWait)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2: return [4 /*yield*/, delay(softWait)];
                    case 3:
                        _a.sent();
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
                        safeWrite(this.WriteCharacteristic, getReadStartPackage("oxi.dat"));
                        iDelay = 0;
                        _a.label = 4;
                    case 4:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, delay(softWait)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 6:
                        if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0) {
                            this.LAST_COMMAND = 0;
                        }
                        iDelay += 1;
                        this.SPO2Items = parseSPO2Items(this.fileCheckMeProGlobalReceiveData);
                        this.fileCheckMeProGlobalReceiveData = [];
                        this.resetValues();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.handleData = function (e) {
        var instance = CheckMeProBleDevice.getInstance();
        var t = e.target;
        var receivedData = new Int8Array(t.value.byteLength);
        if (instance.LastCommand == CHECKMEPRO_COMAND_END) {
            this.LAST_COMMAND = 0;
            instance.globalCheckMeProReceiveData = [];
            return;
        }
        if (t.value.byteLength == 12 && t.value.getInt8(1) == 1) {
            if (t.value.getInt8(8) == 9)
                console.log("file non presente");
            this.LAST_COMMAND = 0;
            instance.globalCheckMeProReceiveData = [];
            return;
        }
        // loop through each byte
        for (var i = 0; i < t.value.byteLength; i++) {
            receivedData[i] = t.value.getInt8(i);
            instance.globalCheckMeProReceiveData.push(t.value.getInt8(i));
            var value = t.value.getInt8(i);
        }
        if (instance.globalCheckMeProReceiveData[instance.globalCheckMeProReceiveData.length - 1] == crc8(instance.globalCheckMeProReceiveData)) {
            console.log("read end");
            switch (instance.LAST_COMMAND) {
                case CHECKMEPRO_COMAND_DEVICEINFO:
                    instance.parseDeviceInfo();
                    break;
                case CHECKMEPRO_COMAND_STARTREAD:
                    instance.parseStartRead();
                    break;
                case CHECKMEPRO_COMAND_READDATA:
                    instance.parseReadData();
                    break;
                default:
                    this.LAST_COMMAND = 0;
                    break;
            }
            instance.globalCheckMeProReceiveData = [];
        }
    };
    CheckMeProBleDevice.prototype.parseDeviceInfo = function () {
        var returnString = "";
        for (var i = 7; i < this.globalCheckMeProReceiveData.length - 8; i++) {
            if (this.globalCheckMeProReceiveData[i] == 0) {
                continue;
            }
            returnString += String.fromCharCode(this.globalCheckMeProReceiveData[i]);
        }
        this.Device = JSON.parse(returnString);
        this.LAST_COMMAND = 0;
        this.fileCheckMeProGlobalReceiveData = [];
        console.log(returnString);
    };
    CheckMeProBleDevice.prototype.parseStartRead = function () {
        this.LAST_COMMAND = CHECKMEPRO_COMAND_READDATA;
        var buf = this.globalCheckMeProReceiveData;
        var fileSize = (buf[7] & 0xff) |
            ((buf[8] & 0xff) << 8) |
            ((buf[9] & 0xff) << 16) |
            ((buf[10] & 0xff) << 24);
        this.filesize = fileSize;
        this.WriteCharacteristic.writeValue(getReadDataPackage(0));
    };
    CheckMeProBleDevice.prototype.resetValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.WriteCharacteristic.writeValue(getEndReadPackage()).catch(function () {
                            console.log("DOMException: GATT operation already in progress.");
                            return Promise.resolve()
                                .then(function () { return delay(softWait); })
                                .then(function () {
                                _this.WriteCharacteristic.writeValue(getEndReadPackage());
                            });
                        });
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_END;
                        this.currentpkg = 0;
                        this.LAST_FILE_COMMAND = 0;
                        return [4 /*yield*/, delay(softWait).then(function () { return _this.LAST_COMMAND = 0; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckMeProBleDevice.prototype.parseReadData = function () {
        var _this = this;
        this.progress.value =
            this.fileCheckMeProGlobalReceiveData.length.toString() +
                "/ " +
                this.filesize +
                "(" +
                this.currentpkg +
                " )";
        console.log(this.progress.value);
        var bufferLength = 520;
        if (this.filesize < bufferLength) {
            bufferLength = this.filesize;
        }
        if (this.globalCheckMeProReceiveData[1] != 0) {
            this.resetValues();
            return;
        }
        this.LAST_COMMAND = CHECKMEPRO_COMAND_READDATA;
        var pknumber = this.globalCheckMeProReceiveData[3];
        var buf = this.globalCheckMeProReceiveData;
        var pkg = this.filesize / (520 - 8);
        if (this.fileCheckMeProGlobalReceiveData.length >= this.filesize ||
            this.currentpkg > pkg + 25 ||
            this.globalCheckMeProReceiveData.length == 8 ||
            this.globalCheckMeProReceiveData.length == this.filesize + 8) {
            for (var i = 7; i < this.globalCheckMeProReceiveData.length - 1; i++) {
                this.fileCheckMeProGlobalReceiveData.push(this.globalCheckMeProReceiveData[i]);
            }
            this.LAST_COMMAND = 0;
            return;
        }
        this.currentpkg += 1;
        for (var i = 7; i < this.globalCheckMeProReceiveData.length - 1; i++) {
            this.fileCheckMeProGlobalReceiveData.push(this.globalCheckMeProReceiveData[i]);
        }
        console.log(" pkc" + this.currentpkg);
        console.log(this.globalCheckMeProReceiveData.length);
        console.log(" pkc" + this.currentpkg);
        this.WriteCharacteristic.writeValue(getReadDataPackage(this.currentpkg)).catch(function () {
            console.log("DOMException: GATT operation already in progress.");
            return Promise.resolve()
                .then(function () { return delay(500); })
                .then(function () {
                _this.WriteCharacteristic.writeValue(getReadDataPackage(_this.currentpkg));
            });
        });
    };
    CheckMeProBleDevice.prototype.readEcgItem = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (item.innerItem != null)
                            return [2 /*return*/];
                        this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
                        this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_ITEM_FILE;
                        this.WriteCharacteristic.writeValue(getReadStartPackage(getFileName(item.date)));
                        this.LAST_FILE_NAME = getFileName(item.date);
                        this.LAST_FILE_ITEM = item;
                        _a.label = 1;
                    case 1:
                        if (!(this.LAST_COMMAND != 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, delay(softWait)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CheckMeProBleDevice;
}());
export { CheckMeProBleDevice };
